export const NUM_CONTENT_ITEMS_PER_PAGE = 25;
export const STEPPER_TITLE = 'Learner enrollment';
export const ADD_LEARNERS_TITLE = 'Add learners';
export const REVIEW_TITLE = 'Review selections';
export const NEXT_BUTTON_TEXT = 'Next';
export const PREVIOUS_BUTTON_TEXT = 'Previous';
export const FINAL_BUTTON_TEXT = 'Enroll learners';
export const NEXT_BUTTON_TEST_ID = 'stepper-next';
export const PREV_BUTTON_TEST_ID = 'stepper-prev';
export const FINAL_BUTTON_TEST_ID = 'stepper-final';
export const NOTIFY_CHECKBOX_TEST_ID = 'notify-checkbox';
export const CUSTOMER_SUPPORT_HYPERLINK_TEST_ID = 'customer-support-hyperlink';
export const REVIEW_STEP = 'review';
export const ADD_COURSES_STEP = 'chooseCourses';
export const ADD_COURSES_TITLE = 'Add courses';
export const ALERT_MODAL_TITLE_TEXT = 'An error occurred behind the scenes';
export const ALERT_MODAL_BODY_TEXT = 'Some or all of your enrollments were not successful. Please '
                                     + 'wait a few minutes and try again. If the problem persists, '
                                     + 'please ';
export const SUPPORT_HYPERLINK_TEXT = 'contact enterprise customer support.';
export const SUPPORT_EMAIL_SUBJECT = 'An error occurred during Subscription Enrollment for enterprise ';
export const SUPPORT_EMAIL_BODY = 'The following error occurred when attempting to enroll learners: ';
export const ADD_COURSE_DESCRIPTION = 'By enrolling your learners in courses, you connect your'
                                      + ' learning community with the content that matters most '
                                      + 'to them, and take the guesswork out of getting started '
                                      + 'on the edX platform. To begin, select a course from '
                                      + 'your subscription catalog.';
export const ADD_LEARNERS_DESCRIPTION = 'Select learners with an active or pending subscription '
                                        + 'license to enroll. If you wish to enroll additional '
                                        + 'learners not shown, please first invite them under ';
export const WARNING_ALERT_TITLE_TEXT = 'Too many courses selected';
export const WARNING_ALERT_BODY_TEXT = 'We noticed that you are trying to enroll learners in over 7 '
                                        + 'courses at once - which might be too many for your learners '
                                        + 'to manage. If this is intentional, please continue with this '
                                        + 'enrollment process. If not, please go back and modify your '
                                        + 'course selections.';
